<section>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <strong>Empfänger</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.recipients }}
    </p>
    <strong>Betreff der E-Mail</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.subject }}
    </p>
    <mat-form-field fxFlex="100">
      <mat-label>Kommentar mitgeben</mat-label>
      <textarea matInput type="text" rows="3" maxlength="255" [(ngModel)]="comment"></textarea>
    </mat-form-field>
  </div>

  <div *ngIf="!approveAfterMeterChange" class="button-container" fxLayout="row" fxLayoutGap="20px">
    <button mat-raised-button color="primary" id="modal-confirm" (click)="confirm(false)">
      Freigabe ohne Zählerwechsel
    </button>
  </div>
  <div *ngIf="!approveAfterMeterChange" class="button-container" fxLayout="row" fxLayoutGap="20px">
    <button mat-raised-button color="primary" id="modal-confirm-with-meter-change" (click)="confirm(true)">
      Zählerwechsel notwendig
    </button>
  </div>
  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button
      mat-raised-button
      *ngIf="approveAfterMeterChange"
      color="primary"
      id="modal-confirm-after-meter-change"
      (click)="confirm(false)">
      <span>Freigeben</span>
    </button>
  </div>
</section>
